export const LIGHT = {
    'name': 'light',
    'color': '#FFFFFF'
};

export const DARK = {
    'name': 'dark',
    'color': '#1C1C1D'
};